import { onMount } from "svelte";
import { on } from "svelte/events";
import type { CinemaItemHTMLElement } from "./observer";

/**
 *
 *
 *
 *
 *
 */
export const useFocusInHandler = (Host: CinemaItemHTMLElement): void => {
  onMount(() =>
    on(Host, "focusin", (event) => {
      const interactiveElement = event.composedPath()[0] as HTMLElement | null;
      const item = event.target as CinemaItemHTMLElement | null;

      if (
        item instanceof HTMLElement &&
        interactiveElement?.matches(":focus-visible") &&
        !item.isVisible
      ) {
        item.scrollIntoView({ inline: "center", block: "nearest" });
      }
    }),
  );
};
